import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootStore } from "../reducers";
import {
  clearMainMenuActiveAction,
  setMainMenuActiveAction,
  setSubMenuOpenedAction,
} from "./action";

export function useHomePage() {
  const dispatch = useDispatch();
  const state = useSelector((state: RootStore) => state.home);

  const bindClearMainMenuActiveAction = useCallback(
    () => dispatch(clearMainMenuActiveAction()),
    [dispatch]
  );
  const bindSetMainMenuActiveAction = useCallback(
    (id: number) => dispatch(setMainMenuActiveAction({ id })),
    [dispatch]
  );
  const bindSetSubMenuOpenedAction = useCallback(
    (opened: boolean) => dispatch(setSubMenuOpenedAction({ opened })),
    [dispatch]
  );

  return {
    ...state,
    setMainMenuActive: bindSetMainMenuActiveAction,
    setSubMenuOpened: bindSetSubMenuOpenedAction,
    clearMainMenuActive: bindClearMainMenuActiveAction,
  };
}
